import React, { FC } from 'react';

import JoinCapIntroPage from 'buyside/components/presentation/JoinCapIntroPage/joinCapIntroPage';

document.getElementById('mainReactApp')?.setAttribute('data-no-padding', 'true');

const JoinCapIntroPageRoot: FC = () => <JoinCapIntroPage />;

export default JoinCapIntroPageRoot;
